import { unregister } from "../registerServiceWorker";

// Get url vars
export const getUrlVars = () => {
    var vars = {};
    var parts = window.location.href.replace(/[?&]+([^=&]+)=([^&]*)/gi, (m,key,value) => {
        vars[key] = value;
    });
    return vars;
}

export const generateRandomPlate = () => {
    var text = "";
    var abc = "ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789";
    for (var i = 0; i < 7; i++)
        text += abc.charAt(Math.floor(Math.random() * abc.length));

    return "WEB_"+text;
}

// This method remove object from array
export const removeObject = (objectsArray, property, valueProperty) => {
    let array = objectsArray;
    array.forEach((item, index) => {
        if(item[property] && item[property] === valueProperty){
            array.splice(index, 1);
        }
    })

    return array;

}

// Funcion que genera un DNI aleatorio
function formatNumberLength(num, length) {
    var r = "" + num;
    while ( r.length < length ) {
      r = "0" + r;
    }
    return r;
}

function charDNI(dni) {
    var chain = "TRWAGMYFPDXBNJZSQVHLCKET";
    var pos = dni % 23;
    var letter = chain.substring( pos, pos + 1 );
    return letter;
}

export function generateDni() {
    var num = Math.floor( ( Math.random() * 100000000 ) );
    var sNum = formatNumberLength( num, 8 );
    return "WEB_" + sNum + charDNI( sNum );
}

// Covert hex colors to rgba colors
export function hexToRgbA(hex, opacity){
    var c;
    if(/^#([A-Fa-f0-9]{3}){1,2}$/.test(hex)){
        c= hex.substring(1).split('');
        if(c.length== 3){
            c= [c[0], c[0], c[1], c[1], c[2], c[2]];
        }
        c= '0x'+c.join('');
        return 'rgba('+[(c>>16)&255, (c>>8)&255, c&255].join(',')+',' + opacity +')';
    }
    throw new Error('Bad Hex');
}

// Allow redirecto to server.
export function redirectServer(url) {
  unregister()
  window.location = url
}



// WEBPACK FOOTER //
// ./src/utils/index.js